// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"be00b3bd","587":"8bda45bd","788":"6fbc4572"}[chunkId] + ".chunk.js";
};